import { render, staticRenderFns } from "./wfpicker.vue?vue&type=template&id=4b9a186e&"
import script from "./wfpicker.vue?vue&type=script&lang=js&"
export * from "./wfpicker.vue?vue&type=script&lang=js&"
import style0 from "./wfpicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports